import React from 'react'
import moment from 'moment'
import { openIntercom } from '../../utils/utils'
import * as constants from '../../utils/constants'

import AppStoreLogo from '../../assets/img/AppStore.png'

import './Footer.css'

const Footer = () => {
  return (
    <footer>
      <div className="row">
        <div className="flex-start">
          <div className="column-footer">
            <ul className="ul-footer">
              <li>
                <a href={constants.HOW_IT_WORKS_URL}>How it works</a>
              </li>
              <li>
                <a href={constants.WHY_COOKUNITY_URL}>Why Cookunity</a>
              </li>
              <li>
                <a href={constants.TERMS_OF_USE_URL}>Terms</a>
              </li>
              <li>
                <a href={constants.PRIVACY_POLICY_URL}>Privacy Policy</a>
              </li>
              <li>
                <a href={constants.BLOG_URL}>Blog</a>
              </li>

              <div className="mobile-p">
                <li>
                  <a href={constants.GIFTCARD_URL}>Gift cards</a>
                </li>
              </div>
            </ul>
          </div>
          <div className="column-footer column-none">
            <ul className="ul-footer">
              <li>
                <a href={constants.GIFTCARD_URL}>Gift cards</a>
              </li>
              <li>
                <a href={constants.BECOME_CHEF_URL}>Become a chef</a>
              </li>
              <li>
                <a href={constants.COOKUNITY_ZENDESK} rel="noopener noreferrer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div className="column-footer column-end">
            <ul className="ul-footer">
              <div className="column-mobile">
                <li>
                  <a href={constants.BECOME_CHEF_URL}>Become a chef</a>
                </li>

                <li>
                  {' '}
                  <a
                    href={constants.COOKUNITY_ZENDESK}
                    target="_blank"
                    rel="noopener noreferrer">
                    FAQ
                  </a>
                </li>
              </div>
              <li>
                <a href={constants.DELIVERY_MAP_URL}>Delivery Map</a>
              </li>
              <li>
                <a href={constants.RECYCLE_URL}> Recycling</a>
              </li>
              <li>
                <span className="live_chat" onClick={openIntercom}>
                  Live Chat
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex-end">
          <ul className="ul-footer row-mobile">
            <div>
              <li className="line-social">
                <a href={constants.COOKUNITY_INSTAGRAM}>Instagram</a>
              </li>
              <li className="line-social">
                <a href={constants.COOKUNITY_TWITTER}>Twitter</a>
              </li>
              <li className="line-social">
                <a href={constants.COOKUNITY_FACEBOOK}>Facebook</a>
              </li>
              <li>
                <a className="mobile-p">
                  <p>{moment().format('Y')} &copy; CookUnity</p>
                </a>
              </li>
            </div>
            <div>
              <li>
                <a href={constants.MAILTO_COOKUNITY}>info@cookunity.com</a>
              </li>
              <li>
                <a href={constants.COOKUNITY_APPSTORE}>
                  <img
                    alt="appstore"
                    className="cookunity-app-store"
                    src={AppStoreLogo}
                  />
                </a>
              </li>
            </div>
          </ul>
        </div>
        <div className="flex-row">
          <p>{moment().format('Y')} &copy; CookUnity</p>
          <div>
            <p>
              <span>No to GMOs</span>
              <i className="fa fa-check" />
            </p>
            <p>
              <span>Small Batches</span>
              <i className="fa fa-check" />
            </p>
            <p>
              <span>Nothing Artificial</span>
              <i className="fa fa-check" />
            </p>
            <p>
              <span>Humanely Raised</span>
              <i className="fa fa-check" />{' '}
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js